import { render, staticRenderFns } from "./WorkspaceTraitNodeInspectorContent.vue?vue&type=template&id=391d05d0&scoped=true"
import script from "./WorkspaceTraitNodeInspectorContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceTraitNodeInspectorContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceTraitNodeInspectorContent.vue?vue&type=style&index=0&id=391d05d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d05d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391d05d0')) {
      api.createRecord('391d05d0', component.options)
    } else {
      api.reload('391d05d0', component.options)
    }
    module.hot.accept("./WorkspaceTraitNodeInspectorContent.vue?vue&type=template&id=391d05d0&scoped=true", function () {
      api.rerender('391d05d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceTraitNodeInspectorContent.vue"
export default component.exports